import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));

// Suppress the benign "ResizeObserver loop" browser warning that CRA's dev
// overlay incorrectly surfaces as a fatal runtime error (triggered by Radix
// UI + smooth scrolling). It does not affect functionality.
const RO_ERROR = /ResizeObserver loop (limit exceeded|completed with undelivered notifications)/;
window.addEventListener("error", (e) => {
  if (e.message && RO_ERROR.test(e.message)) {
    e.stopImmediatePropagation();
    e.preventDefault();
    const ids = ["webpack-dev-server-client-overlay", "webpack-dev-server-client-overlay-div"];
    ids.forEach((id) => {
      const el = document.getElementById(id);
      if (el) el.style.display = "none";
    });
  }
});

root.render(
  <QueryClientProvider client={queryClient}>
    <App />
  </QueryClientProvider>,
);
